import { resolveMediaUrl, FALLBACK_LISTING_IMG } from "@/lib/apiClient";

/**
 * Listing photo with Borough proxy resolution + hard fallback.
 * Use for every property thumbnail / gallery image (sale and rent).
 */
export default function ListingImage({
  src,
  alt = "",
  className = "",
  loading = "lazy",
  decoding = "async",
  ...rest
}) {
  const resolved = resolveMediaUrl(src) || FALLBACK_LISTING_IMG;
  return (
    <img
      src={resolved}
      alt={alt}
      loading={loading}
      decoding={decoding}
      className={className}
      onError={(e) => {
        if (e.currentTarget.src === FALLBACK_LISTING_IMG) return;
        e.currentTarget.onerror = null;
        e.currentTarget.src = FALLBACK_LISTING_IMG;
      }}
      {...rest}
    />
  );
}
